const DEFAULT_FAQ_AUTH_REDIRECT_ORIGIN = 'https://files-system.unilumin.com';

function normalizeFaqBasePath(basePath = '/faq') {
  const trimmedPath = basePath.trim().replace(/^\/+/, '').replace(/\/+$/, '');
  return `/${trimmedPath || 'faq'}`;
}

function normalizeFaqRedirectUrl(rawUrl: string, basePath: string) {
  const trimmedUrl = rawUrl.trim();
  if (!trimmedUrl) return '';

  try {
    const url = new URL(trimmedUrl);
    url.pathname = normalizeFaqBasePath(basePath);
    url.search = '';
    url.hash = '';
    return url.toString().replace(/\/$/, '');
  } catch {
    return trimmedUrl.replace(/\/$/, '');
  }
}

export function getFaqAuthRedirectUrl(basePath = '/faq') {
  const normalizedBasePath = normalizeFaqBasePath(basePath);
  const configuredUrl = normalizeFaqRedirectUrl(
    import.meta.env.VITE_FAQ_AUTH_REDIRECT_URL ?? '',
    normalizedBasePath,
  );
  if (configuredUrl) return configuredUrl;

  if (typeof window !== 'undefined') {
    const { origin, hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${origin}${normalizedBasePath}`;
    }
  }

  return `${DEFAULT_FAQ_AUTH_REDIRECT_ORIGIN}${normalizedBasePath}`;
}
